/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "fa81d6874078dedb06782a17ea11e21c4cbfdc91";
